import { render } from "./Item2.vue?vue&type=template&id=5085cc5c&scoped=true"
import script from "./Item2.vue?vue&type=script&lang=js"
export * from "./Item2.vue?vue&type=script&lang=js"

import "./Item2.vue?vue&type=style&index=0&id=5085cc5c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5085cc5c"

export default script